export const SEARCH_PROJECTS = 'app/Search/SEARCH_PROJECTS'
export const SEARCH_PROJECTS_DONE = 'app/Search/SEARCH_PROJECTS_DONE'
export const SEARCH_PROJECTS_ERROR = 'app/Search/SEARCH_PROJECTS_ERROR'

export const SEARCH_GENERIC_DATASETS = 'app/Search/SEARCH_GENERIC_DATASETS'
export const SEARCH_GENERIC_PINS = 'app/Search/SEARCH_GENERIC_PINS'
export const SEARCH_GENERIC_GROUPS = 'app/Search/SEARCH_GENERIC_GROUPS'
export const SEARCH_GENERIC_TASKS = 'app/Search/SEARCH_GENERIC_TASKS'
export const SEARCH_GENERIC_PLANS = 'app/Search/SEARCH_GENERIC_PLANS'
export const SEARCH_GENERIC_REPORTS = 'app/Search/SEARCH_GENERIC_REPORTS'
export const SEARCH_GENERIC_DONE = 'app/Search/SEARCH_GENERIC_DONE'
export const SEARCH_GENERIC_ERROR = 'app/Search/SEARCH_GENERIC_ERROR'

export const SEARCH_TEAM_MEMBERS = 'app/Search/SEARCH_TEAM_MEMBERS'
export const SEARCH_TEAM_MEMBERS_DONE = 'app/Search/SEARCH_TEAM_MEMBERS_DONE'
export const SEARCH_TEAM_MEMBERS_ERROR = 'app/Search/SEARCH_TEAM_MEMBERS_ERROR'

export const GET_RECENT_SEARCH_REQUESTS =
  'app/Search/GET_RECENT_SEARCH_REQUESTS'
export const ADD_RECENT_SEARCH_REQUEST = 'app/Search/ADD_RECENT_SEARCH_REQUEST'
export const CLEAR_RECENT_SEARCH_REQUESTS =
  'app/Search/CLEAR_RECENT_SEARCH_REQUESTS'

export const OPEN_PROJECTS = 'app/Search/OPEN_PROJECTS'
export const CLOSE_PROJECTS = 'app/Search/CLOSE_PROJECTS'
export const OPEN_PROJECT_FOLDER = 'app/Search/OPEN_PROJECT_FOLDER'
export const SET_PROJECT_FILTER = 'app/Search/SET_PROJECT_FILTER'
